import { Flex, List, ListItem, Typography } from '@coolblue-development/freddy';
import { useTranslation } from '@i18n/useTranslation';

const ModalContent = () => {
  const { t } = useTranslation('webshop.business.leasing.modal');

  return (
    <Flex direction='column' gap={200}>
      <Typography variant='body'>{t('body.intro')}</Typography>

      <Typography variant='h3'>{t('titles.requirements')}</Typography>
      <Typography variant='body'>{t('body.requirements')}</Typography>

      <Typography variant='h3'>{t('titles.steps')}</Typography>
      <List component='ol' marker='emphasised'>
        {[1, 2, 3].map(step => (
          <ListItem key={step}>{t(`body.steps.${step}`)}</ListItem>
        ))}
      </List>
    </Flex>
  );
};

export default ModalContent;
